// import { useState, useEffect } from "react";
// import { IoIosCloseCircleOutline } from "react-icons/io";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";

// function Login2({ isOpen, onClose }) {
//   const [step, setStep] = useState(1);
//   const [mobile, setMobile] = useState("");
//   const [otp, setOtp] = useState("");
//   const [isOtpSent, setIsOtpSent] = useState(false);
//   const [message, setMessage] = useState({ text: "", type: "" });
//   const navigate = useNavigate();
//   const [loginBannerImage, setLoginBannerImage] = useState(
//     "https://placehold.co/400x400"
//   );
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     city: "",
//     address: "",
//     latitude: "",
//     longitude: "",
//     user_type: "Customer",
//     admin_auto_id: sessionStorage.getItem("admin_auto_id"),
//     country_code: "IN-91",
//     country_name: "India",
//   });
//   const [isSignUp, setIsSignUp] = useState(false);
//   const [themeColor,setThemeColor]=useState("#000000")
//   const [themeIconColor,setThemeIconColor]=useState("#000000");
//   const [webFont, setWebFont] = useState("");
//   const [verifyingOtp, setVerifyingOtp] = useState(false);


//   useEffect(() => {
//     const storedStyle = sessionStorage.getItem("UIStyle");
//     if (storedStyle) {
//       const parsedStyle = JSON.parse(storedStyle);
//       setThemeColor(parsedStyle.web_theme_colour);
//       setThemeIconColor(parsedStyle.web_theme_icon_color);
//       setWebFont(parsedStyle.web_font);
//     }
//   }, []); 


//   function lightenHexColor(hex, percent) {
//     const num = parseInt(hex.replace("#", ""), 16);
//     let r = (num >> 16) + 255 * percent;
//     let g = ((num >> 8) & 0x00ff) + 255 * percent;
//     let b = (num & 0x0000ff) + 255 * percent;
  
//     r = Math.max(0, Math.min(255, Math.round(r)));
//     g = Math.max(0, Math.min(255, Math.round(g)));
//     b = Math.max(0, Math.min(255, Math.round(b)));
  
//     return `rgb(${r}, ${g}, ${b})`;
//   }
  
//   function darkenHexColor(hex, percent) {
//     const num = parseInt(hex.replace("#", ""), 16);
//     let r = (num >> 16) - 255 * percent;
//     let g = ((num >> 8) & 0x00ff) - 255 * percent;
//     let b = (num & 0x0000ff) - 255 * percent;
  
//     r = Math.max(0, Math.min(255, Math.round(r)));
//     g = Math.max(0, Math.min(255, Math.round(g)));
//     b = Math.max(0, Math.min(255, Math.round(b)));
  
//     return `rgb(${r}, ${g}, ${b})`;
//   }

//   const handleSendOtp = async () => {
//     if (mobile.length !== 10) {
//       setMessage({ text: "Please enter a valid 10-digit phone number.", type: "error" });
//       return;
//     }

//     try {
//       const apiURL = isSignUp
//         ? `${process.env.REACT_APP_API_BASE_URL}/send_registration_otp`
//         : `${process.env.REACT_APP_API_BASE_URL}/send_login_otp`;

//       const payload = isSignUp
//         ? {
//             mobile_number: mobile,
//             user_type: formData.user_type,
//             admin_auto_id: formData.admin_auto_id,
//           }
//         : {
//             mobile_number: mobile,
//             user_type: formData.user_type,
//             country_code: formData.country_code,
//           };

//       const response = await axios.post(apiURL, payload);
//       if (response.data.status === "1") {
//         setIsOtpSent(true);
//         setStep(2);
//         setMessage({ text: response.data.msg || "OTP sent successfully.", type: "success" });
//       } else {
//         setMessage({ text: response.data.msg || "Error sending OTP.", type: "error" });
//       }
//     } catch (error) {
//       setMessage({
//         text: "Error sending OTP: " + (error.response?.data?.msg || error.message),
//         type: "error",
//       });
//     }
//   };

//   useEffect(() => {
//     if (!isSignUp || !formData.city || !formData.address) return;

//     const fetchCoordinates = async () => {
//       const address = `${formData.address}, ${formData.city}, ${formData.country_name}`;
//       const apiKey = "AIzaSyCY4i1-nQFNVTSYetMw7aofzBRwGvCH_Ms";

//       try {
//         const response = await axios.get(
//           "https://maps.googleapis.com/maps/api/geocode/json",
//           { params: { address, key: apiKey } }
//         );

//         if (response.data.status === "OK") {
//           const location = response.data.results[0].geometry.location;
//           setFormData((prev) => ({
//             ...prev,
//             latitude: location.lat,
//             longitude: location.lng,
//           }));
//         } else {
//           console.error("Geocoding API Error:", response.data.status);
//         }
//       } catch (error) {
//         console.error("Error fetching location:", error);
//       }
//     };

//     fetchCoordinates();
//   }, [isSignUp, formData.city, formData.address]);

//   const handleVerifyOtp = async () => {
//     setVerifyingOtp(true);
//     try {
//       const apiURL = isSignUp
//         ? `${process.env.REACT_APP_API_BASE_URL}/verify_registration_otp`
//         : `${process.env.REACT_APP_API_BASE_URL}/login`;

//       const payload = isSignUp
//         ? {
//             mobile_number: mobile,
//             otp: otp,
//             user_type: formData.user_type,
//             admin_auto_id: formData.admin_auto_id,
//           }
//         : {
//             mobile_number: mobile,
//             user_type: formData.user_type,
//             country_code: formData.country_code,
//             admin_auto_id: formData.admin_auto_id,
//             otp: otp,
//           };

//       const response = await axios.post(apiURL, payload);
//       if (response.data.status === "1") {
//         sessionStorage.setItem("accessToken", response.data.user_id);
//         if (isSignUp) {
//           await handleUserRegistration();
//         } else {
//           setMessage({ text: response.data.msg || "Login successful!", type: "success" });
//           setTimeout(() => {
//             onClose();
//             window.location.reload();
//           }, 3000);
//         }
//       } else {
//         setMessage({ text: response.data.msg || "Error verifying OTP.", type: "error" });
//       }
//     } catch (error) {
//       setMessage({
//         text: "Error verifying OTP: " + (error.response?.data?.msg || error.message),
//         type: "error",
//       });
//     }
//     finally {
//       setVerifyingOtp(false);
//     }
//   };

//   useEffect(() => {
//     if (otp.length === 4 && !verifyingOtp) {
//       handleVerifyOtp();
//     }
//   }, [otp]);

//   const handleUserRegistration = async () => {
//     if (!isSignUp) return;

//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_BASE_URL}/user_registration`,
//         { ...formData, mobile_number: mobile }
//       );

//       if (response.data.status === "1") {
//         const userAutoId = response.data.user_auto_id;
//         sessionStorage.setItem("accessToken", userAutoId);
//         setMessage({ text: response.data.msg || "Registration successful!", type: "success" });
//         setTimeout(() => {
//           onClose();
//           window.location.reload();
//         }, 3000);
//       } else {
//         setMessage({ text: response.data.msg || "Error during registration.", type: "error" });
//       }
//     } catch (error) {
//       setMessage({
//         text: "Error during registration: " + (error.response?.data?.msg || error.message),
//         type: "error",
//       });
//     }
//   };

//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   useEffect(() => {
//     const storedStyle = sessionStorage.getItem("UIStyle");
//     if (storedStyle) {
//       try {
//         const parsedStyle = JSON.parse(storedStyle);
//         if (parsedStyle?.login_banner_image) {
//           const imageUrl = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/business_details/${parsedStyle.login_banner_image}`;
//           setLoginBannerImage(imageUrl);
//         }
//       } catch (error) {
//         console.error("Error parsing UIStyle from sessionStorage:", error);
//       }
//     }
//   }, []);

//   // Clear message after 2 seconds
//   useEffect(() => {
//     if (message.text) {
//       const timer = setTimeout(() => {
//         setMessage({ text: "", type: "" });
//       }, 2000);
//       return () => clearTimeout(timer);
//     }
//   }, [message.text]);



//   return (
//     <div
//       className={`fixed inset-0 bg-black bg-opacity-50 transition-all z-50 ${webFont} ${
//         isOpen ? "visible" : "invisible"
//       }`}
//     >
//       <button
//         className="absolute top-4 right-[400px] text-white text-4xl"
//         onClick={onClose}
//       >
//         <IoIosCloseCircleOutline />
//       </button>

//       <div
//         className={`fixed top-0 right-0 h-full w-[400px] bg-white shadow-lg transform transition-transform duration-300 ${
//           isOpen ? "translate-x-0" : "translate-x-full"
//         }`}
//         style={{
//           backgroundImage: `url(${loginBannerImage})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div
//           className={`fixed ${
//             isSignUp ? "top-20 h-[525px]" : "top-44 h-[400px]"
//           } right-0 w-96 bg-white shadow-xl p-2 flex flex-col mx-2 rounded`}
//         >
//           <h2 className="mb-2 text-xl font-bold text-black">
//             {isSignUp ? "Sign Up" : "Sign In"}
//           </h2>
//           {message.text && (
//             <div
//               className={`text-center p-2 text-sm mb-2 ${
//                 message.type === "error" ? "text-red-500" : "text-green-500"
//               }`}
//             >
//               {message.text}
//             </div>
//           )}
//           {isSignUp && (
//             <>
//               <label className="text-sm text-black">Name</label>
//               <input
//                 type="text"
//                 className="w-full p-2 mt-1 text-black bg-white border-b-2"
//                 value={formData.name}
//                 onChange={(e) =>
//                   setFormData({ ...formData, name: e.target.value })
//                 }
//               />
//               <label className="text-sm text-black">Email</label>
//               <input
//                 type="email"
//                 className="w-full p-2 mt-1 text-black bg-white border-b-2"
//                 value={formData.email}
//                 onChange={(e) =>
//                   setFormData({ ...formData, email: e.target.value })
//                 }
//               />
//               <label className="text-sm text-black">City</label>
//               <input
//                 type="text"
//                 className="w-full p-2 mt-1 text-black bg-white border-b-2"
//                 value={formData.city}
//                 onChange={(e) =>
//                   setFormData({ ...formData, city: e.target.value })
//                 }
//               />
//               <label className="text-sm text-black">Address</label>
//               <input
//                 type="text"
//                 className="w-full p-2 mt-1 text-black bg-white border-b-2"
//                 value={formData.address}
//                 onChange={(e) =>
//                   setFormData({ ...formData, address: e.target.value })
//                 }
//               />
//             </>
//           )}
//           <label className="text-sm text-black">Mobile Number</label>
//           <input
//             type="text"
//             className="w-full p-2 mt-1 text-black bg-white border-b-2"
//             value={mobile}
//             onChange={(e) => setMobile(e.target.value)}
//           />
//           {step === 1 ? (
//             <>
//               <div className="flex justify-center gap-1">
//               <button
//                 className={`mt-4 w-full py-2 rounded text-lg font-semibold text-white ${
//                   mobile.length === 10 ? "" : "bg-gray-400"
//                 }`}
//                 style={{
//                   backgroundColor: mobile.length === 10 ? themeColor : undefined,
//                 }}
//                 onClick={handleSendOtp}
//                 disabled={mobile.length !== 10}
//               >
//                 Proceed Via OTP
//               </button>
//               </div>
//               <p className="mt-2 text-xs text-right cursor-pointer">
//                 {isSignUp ? "Existing user " : "New user "}
//                 <Link
//                   to="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     setIsSignUp(!isSignUp);
//                   }}
//                   style={{ color: themeColor }}
//                     onMouseEnter={(e) => {
//                       const darkenedColor = darkenHexColor(themeColor, 0.15);
//                       e.currentTarget.style.color = darkenedColor;
//                     }}
//                     onMouseLeave={(e) => {
//                       e.currentTarget.style.color = themeColor;
//                     }}
//                 >
//                   {isSignUp ? "Sign In" : "Sign Up"}
//                 </Link>
//               </p>
//             </>
//           ) : (
//             <>
//               <label className="text-sm text-black">Enter OTP</label>
//               <div className="relative w-full">
//                 <input
//                   type="text"
//                   className="w-full p-2 pr-16 mt-1 text-black bg-white border-b-2"
//                   value={otp}
//                   onChange={(e) => setOtp(e.target.value)}
//                 />
//                 <button
//                   className="absolute text-sm text-red-600 transform -translate-y-1/2 right-2 top-1/2"
//                   onClick={handleSendOtp}
//                 >
//                   Resend
//                 </button>
//               </div>
//               <button
//               className={`mt-4 w-full py-2 rounded text-lg font-semibold text-white ${
//                 otp.length === 4 && !verifyingOtp ? "opacity-100" : "opacity-60"
//               }`}
//               style={{ backgroundColor: themeColor }}
//               disabled
//             >
//               {verifyingOtp ? "Verifying..." : "Confirm OTP"}
//             </button>

//             </>
//           )}
//           <p className="flex justify-center mt-2 text-sm text-black">
//             By signing in you agree to our{" "}
//             <Link
//               className="pl-1 underline"
//               to="/termsandcondition"
//               style={{color:themeColor}}
//             >
//               terms and conditions
//             </Link>
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// }
// export default Login2;


import { useState, useEffect } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

function Login2({ isOpen, onClose }) {
  const [step, setStep] = useState(1);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const navigate = useNavigate();
  const [loginBannerImage, setLoginBannerImage] = useState(
    "https://placehold.co/400x400"
  );
  const [formData, setFormData] = useState({
    name: "",
    email_id: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    user_type: "Customer",
    admin_auto_id: sessionStorage.getItem("admin_auto_id"),
    country_code: "IN-91",
    country_name: "India",
  });
  const [isSignUp, setIsSignUp] = useState(false);
  const [themeColor, setThemeColor] = useState("#000000");
  const [themeIconColor, setThemeIconColor] = useState("#000000");
  const [webFont, setWebFont] = useState("");
  const [verifyingOtp, setVerifyingOtp] = useState(false);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color);
      setWebFont(parsedStyle.web_font);
    }
  }, []);

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  const handleSendOtp = async () => {
    if (mobile.length !== 10) {
      setMessage({
        text: "Please enter a valid 10-digit phone number.",
        type: "error",
      });
      return;
    }

    try {
      const apiURL = isSignUp
        ? `${process.env.REACT_APP_API_BASE_URL}/send_registration_otp`
        : `${process.env.REACT_APP_API_BASE_URL}/send_login_otp`;

      const payload = isSignUp
        ? {
            mobile_number: mobile,
            user_type: formData.user_type,
            admin_auto_id: formData.admin_auto_id,
          }
        : {
            mobile_number: mobile,
            user_type: formData.user_type,
            country_code: formData.country_code,
            admin_auto_id: formData.admin_auto_id,
          };

      const response = await axios.post(apiURL, payload);
      if (response.data.status === "1") {
        setIsOtpSent(true);
        setStep(2);
        setMessage({
          text: response.data.msg || "OTP sent successfully.",
          type: "success",
        });
      } else {
        setMessage({
          text: response.data.msg || "Error sending OTP.",
          type: "error",
        });
      }
    } catch (error) {
      setMessage({
        text: "Error sending OTP: " + (error.response?.data?.msg || error.message),
        type: "error",
      });
    }
  };

  useEffect(() => {
    if (!isSignUp || !formData.city || !formData.address) return;

    const fetchCoordinates = async () => {
      const address = `${formData.address}, ${formData.city}, ${formData.country_name}`;
      const apiKey = "AIzaSyAt8bj4UACvakZfiSy-0c1o_ivfplm7jEU";

      try {
        const response = await axios.get(
          "https://maps.googleapis.com/maps/api/geocode/json",
          { params: { address, key: apiKey } }
        );

        if (response.data.status === "OK") {
          const location = response.data.results[0].geometry.location;
          setFormData((prev) => ({
            ...prev,
            latitude: location.lat,
            longitude: location.lng,
          }));
        } else {
          console.error("Geocoding API Error:", response.data.status);
        }
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    fetchCoordinates();
  }, [isSignUp, formData.city, formData.address]);

  const handleVerifyOtp = async () => {
    setVerifyingOtp(true);
    try {
      const apiURL = isSignUp
        ? `${process.env.REACT_APP_API_BASE_URL}/verify_registration_otp`
        : `${process.env.REACT_APP_API_BASE_URL}/login`;

      const payload = isSignUp
        ? {
            mobile_number: mobile,
            otp: otp,
            user_type: formData.user_type,
            admin_auto_id: formData.admin_auto_id,
          }
        : {
            mobile_number: mobile,
            user_type: formData.user_type,
            country_code: formData.country_code,
            admin_auto_id: formData.admin_auto_id,
            otp: otp,
          };

      const response = await axios.post(apiURL, payload);
      if (response.data.status === "1") {
        sessionStorage.setItem("accessToken", response.data.user_id);
        if (isSignUp) {
          await handleUserRegistration();
        } else {
          setMessage({
            text: response.data.msg || "Login successful!",
            type: "success",
          });
          setTimeout(() => {
            onClose();
            window.location.reload();
          }, 3000);
        }
      } else {
        setMessage({
          text: response.data.msg || "Error verifying OTP.",
          type: "error",
        });
      }
    } catch (error) {
      setMessage({
        text: "Error verifying OTP: " + (error.response?.data?.msg || error.message),
        type: "error",
      });
    } finally {
      setVerifyingOtp(false);
    }
  };

  useEffect(() => {
    if (otp.length === 4 && !verifyingOtp) {
      handleVerifyOtp();
    }
  }, [otp]);

  const handleUserRegistration = async () => {
    if (!isSignUp) return;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/user_registration`,
        { ...formData, mobile_number: mobile }
      );

      if (response.data.status === "1") {
        const userAutoId = response.data.user_auto_id;
        sessionStorage.setItem("accessToken", userAutoId);
        setMessage({
          text: response.data.msg || "Registration successful!",
          type: "success",
        });
        setTimeout(() => {
          onClose();
          window.location.reload();
        }, 3000);
      } else {
        setMessage({
          text: response.data.msg || "Error during registration.",
          type: "error",
        });
      }
    } catch (error) {
      setMessage({
        text: "Error during registration: " + (error.response?.data?.msg || error.message),
        type: "error",
      });
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      try {
        const parsedStyle = JSON.parse(storedStyle);
        if (parsedStyle?.login_banner_image) {
          const imageUrl = `https://grobizapp-n.s3.ap-south-1.amazonaws.com/business_details/${parsedStyle.login_banner_image}`;
          setLoginBannerImage(imageUrl);
        }
      } catch (error) {
        console.error("Error parsing UIStyle from sessionStorage:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (message.text) {
      const timer = setTimeout(() => {
        setMessage({ text: "", type: "" });
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [message.text]);

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-50 transition-all z-50 ${webFont} ${
        isOpen ? "visible opacity-100" : "invisible opacity-0"
      }`}
    >
      {/*  Close button (responsive & always visible) */}
      <button
        className="absolute top-4 right-4 sm:right-[440px] text-white text-4xl z-[60]"
        onClick={onClose}
      >
        <IoIosCloseCircleOutline />
      </button>

      {/*  Sidebar (responsive width) */}
      <div
        className={`fixed top-0 right-0 h-full w-[92vw] sm:w-[420px] md:w-[440px] bg-white shadow-lg transform transition-transform duration-300 ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
        style={{
          backgroundImage: `url(${loginBannerImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/*  inner form card: responsive height + scroll */}
        <div
          className={`fixed right-0 w-[88vw] sm:w-[380px] md:w-[400px] bg-white shadow-xl p-3 sm:p-4 flex flex-col mx-2 rounded ${
            isSignUp ? "top-16" : "top-28 sm:top-44"
          }`}
          style={{
            maxHeight: isSignUp ? "calc(100vh - 90px)" : "calc(100vh - 170px)",
            overflowY: "auto",
          }}
        >
          <h2 className="mb-2 text-xl font-bold text-black">
            {isSignUp ? "Sign Up" : "Sign In"}
          </h2>

          {message.text && (
            <div
              className={`text-center p-2 text-sm mb-2 ${
                message.type === "error" ? "text-red-500" : "text-green-500"
              }`}
            >
              {message.text}
            </div>
          )}

          {isSignUp && (
            <>
              <label className="text-sm text-black">Name</label>
              <input
                type="text"
                className="w-full p-2 mt-1 text-black bg-white border-b-2 outline-none"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />

              <label className="mt-2 text-sm text-black">Email</label>
              <input
                type="email"
                className="w-full p-2 mt-1 text-black bg-white border-b-2 outline-none"
                value={formData.email_id}
                onChange={(e) => setFormData({ ...formData, email_id: e.target.value })}
              />

              <label className="mt-2 text-sm text-black">City</label>
              <input
                type="text"
                className="w-full p-2 mt-1 text-black bg-white border-b-2 outline-none"
                value={formData.city}
                onChange={(e) => setFormData({ ...formData, city: e.target.value })}
              />

              <label className="mt-2 text-sm text-black">Address</label>
              <input
                type="text"
                className="w-full p-2 mt-1 text-black bg-white border-b-2 outline-none"
                value={formData.address}
                onChange={(e) =>
                  setFormData({ ...formData, address: e.target.value })
                }
              />
            </>
          )}

          <label className="mt-3 text-sm text-black">Mobile Number</label>
          <input
            type="text"
            className="w-full p-2 mt-1 text-black bg-white border-b-2 outline-none"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />

          {step === 1 ? (
            <>
              <div className="flex justify-center gap-1">
                <button
                  className={`mt-4 w-full py-2 rounded text-base sm:text-lg font-semibold text-white ${
                    mobile.length === 10 ? "" : "bg-gray-400"
                  }`}
                  style={{
                    backgroundColor: mobile.length === 10 ? themeColor : undefined,
                  }}
                  onClick={handleSendOtp}
                  disabled={mobile.length !== 10}
                >
                  Proceed Via OTP
                </button>
              </div>

              <p className="mt-2 text-xs text-right cursor-pointer">
                {isSignUp ? "Existing user " : "New user "}
                <Link
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsSignUp(!isSignUp);
                  }}
                  style={{ color: themeColor }}
                  onMouseEnter={(e) => {
                    const darkenedColor = darkenHexColor(themeColor, 0.15);
                    e.currentTarget.style.color = darkenedColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = themeColor;
                  }}
                >
                  {isSignUp ? "Sign In" : "Sign Up"}
                </Link>
              </p>
            </>
          ) : (
            <>
              <label className="mt-2 text-sm text-black">Enter OTP</label>

              <div className="relative w-full">
                <input
                  type="text"
                  className="w-full p-2 pr-20 mt-1 text-black bg-white border-b-2 outline-none"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
                <button
                  className="absolute text-sm text-red-600 transform -translate-y-1/2 right-2 top-1/2"
                  onClick={handleSendOtp}
                >
                  Resend
                </button>
              </div>

              <button
                className={`mt-4 w-full py-2 rounded text-base sm:text-lg font-semibold text-white ${
                  otp.length === 4 && !verifyingOtp ? "opacity-100" : "opacity-60"
                }`}
                style={{ backgroundColor: themeColor }}
                disabled
              >
                {verifyingOtp ? "Verifying..." : "Confirm OTP"}
              </button>
            </>
          )}

          {/*  Responsive terms */}
          <p className="flex flex-wrap justify-center mt-3 text-[11px] sm:text-sm text-black text-center gap-x-1 gap-y-1 px-2">
            <span>By signing in you agree to our</span>
            <Link
              className="underline whitespace-nowrap"
              to="/termsandcondition"
              onClick={() => onClose()}
              style={{ color: themeColor }}
            >
              terms and conditions
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login2;
